import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";

//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr = [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;

//const inboundData = [{"brand": "WH1", "po_number": "123", "type": "test", "po_date" : "23-09-2022" }, {"brand": "WH2", "po_number": "1234", "type": "test1", "po_date" : "23-09-2022" }, {"brand": "WH1", "po_number": "12309", "type": "test", "po_date" : "23-09-2022" }, {"brand": "WH1", "po_number": "123", "type": "test", "po_date" : "23-09-2022" }, {"brand": "WH2", "po_number": "123", "type": "test", "po_date" : "23-09-2022" }, {"brand": "WH3", "po_number": "12389", "type": "test0", "po_date" : "23-09-2022" } ]

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.toggle = this.toggle.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmtoggle1 = this.SuccessConfirmtoggle1.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.handleChangeASN = this.handleChangeASN.bind(this);
    this.handleChangeVan1 = this.handleChangeVan1.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.Assign = this.Assign.bind(this);
    this.OpenAssign = this.OpenAssign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggleOKNew = this.toggleOKNew.bind(this);
    this.toggleNew = this.toggleNew.bind(this);

    this.toggle1 = this.toggle1.bind(this);
    this.onGroupNameChange = this.onGroupNameChange.bind(this);
    this.toggleNPICancel = this.toggleNPICancel.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.onConfirmProduct = this.onConfirmProduct.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.changeDesc = this.changeDesc.bind(this);
    this.changeMargin = this.changeMargin.bind(this);
    this.changeItemType = this.changeItemType.bind(this);
    this.changeCostPrice = this.changeCostPrice.bind(this);
    this.changeSellingPrice = this.changeSellingPrice.bind(this);
    this.changeHSNCode = this.changeHSNCode.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeLocation = this.ChangeLocation.bind(this);
    this.ChangeOutlet = this.ChangeOutlet.bind(this);
    this.AssignData = this.AssignData.bind(this);
    this.AssignData1 = this.AssignData1.bind(this);
    this.getReason = this.getReason.bind(this);

    this.Failedtoggle = this.Failedtoggle.bind(this);
    //this.toggleTooltip = this.toggleTooltip.bind(this);

    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
      orderdata: [],
      variant_data: [],
      arr_data1: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      disable_inbound: false,
      totalTonnage: 0,
      totalWeightVal: 0,
      modalNew: false,
      createDisabled: false,
      tooltipOpen: false,
      showCreatedId: false,
      showFilter: false,
      ShowConfirmLoader: false,
      inboundData: [],
      reasonData: [],
      totalBillVal: 0,
      selectedVan1: "",
      reviewErr: "",
      selectedLocation1: "",
      showSelectGroup: false,
      showNewGroup: false,
      unAssignOrder: [],
      van_list: [],
      assignOrder: [],
      isDisabledSearch: false,
      autoDesc: "",
      selectedDistributor: "",
      isChecked: false,
      autoLongName: "",
      autoShortName: "",
      showConfirmError: false,
      selectedVan: "",
      autoCostPrice: "",
      autoSellingPrice: "",
      stationData: [],
      zoneData: [],
      reviewData: [],
      group_id: "",
      autoHsnCode: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      autoDesc: "",
      autoMargin: "",
      autoItemtype: "",
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      FailedModal: false,
      order: [],
      row_data: [],
      arr_data: [],
      Polaris: [],
      task_type: [],
      pack_size1: [],
      variant1: [],
      task: [],
      store: [],
      distributor: [],
      areaCode: [],
      location: [],
      EditModal: false,
      selectedVanFilter: "",
      fromdate: "",
      todate: "",
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      color_variant: false,
      applyShelfLife: "",
      applyPackUOM: "",
      applyShelfUOM: "",
      applyTax: "",
      applyVariant: "",
      color_mrp: false,
      color_shelf: false,
      color_mc_code: false,
      color_brand: false,
      color_tax: false,
      assignLoader: false,
      assignDisabled: true,
      color_ean: false,
      color_product: false,
      product_name_val: "",
      applyMrp: "",
      status_type: "1",
      apply: true,
      store_id: "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
      longName: "",
      brand: "",
      mrp: "",
      ean: "",
      variant: "",
      shelf_life: "",
      //showCreatedId: false,
      image1: "",
      image2: "",
      image3: "",
      image4: "",
      image5: "",
      groupName: "",

      pack_unit: "",
      shelf_unit: "",
      showFetchDispatchData: true,

      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",

      apply1: true,
      total_value: "",
      total_quantity: "",

      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      weight: "",
      volume: "",
      bill_number: "",
      bill_range: "",
      bill_value: "",
      pl_group: "",
      area_code: "",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showPackSize: false,
      showShelfLife: false,
      color_packSize: false,
      createLoader: false,
      new_brand: "",
      new_pack_size: "",
      new_shelf_life: "",
      new_tax_percentage: "",
      failed_message: "",
      new_variant: "",
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      autoShelfLife: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
    };
  }

  Assign() {
    this.fetchDispatch();
  }

  onGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }

  UnAssign() {
    this.setState({
      loading_overlay: true,
    });
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/orders/", { param: payload })
      .then((response) => {
        console.log(response.data.data.unassigned_orders);
        this.setState({
          showUnAssignedOrder: false,
          showAssignedOrder: true,
          unAssignOrder: response.data.data.unassigned_orders,
          assignOrder: response.data.data.assigned_orders,
          loading_overlay: false,
        });
      })
      .catch(function (error) {});
  }



  ChangeZone(evt, index) {
    const { reviewData } = this.state;
    var Zone = evt.target.value;
    reviewData[index]["zone"] = Zone;

    console.log(reviewData);

    this.setState({
      reviewData: reviewData,
    });
  }

 


  changeDesc = (evt) => {
    this.setState({
      autoDesc: evt.target.value,
    });
  };

  changeSellingPrice = (evt) => {
    this.setState({
      autoSellingPrice: evt.target.value,
    });
  };

  changeCostPrice = (evt) => {
    this.setState({
      autoCostPrice: evt.target.value,
    });
  };
  changeHSNCode = (evt) => {
    this.setState({
      autoHsnCode: evt.target.value,
    });
  };

  changeItemType = (evt) => {
    this.setState({
      autoItemtype: evt.target.value,
    });
  };

  changeMargin = (evt) => {
    this.setState({
      autoMargin: evt.target.value,
    });
  };

  viewImage() {
    //window.open('/view_image','_blank');
    this.props.history.push("/npi_request_data");
  }

 

  changeMCCode = (evt) => {
    this.setState({
      mc_error: false,
      mc_code_value: evt.target.value,
    });
  };

  AssignData() {
    this.setState({
      assignLoader: true,
      assignDisabled: true,
    });
    var arrayData = this.state.arr_data.filter(
      (item) => item.isChecked === true
    );

    var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      arr.push(arrayData[i].id);
    }
    var req_id = [];

    /*for(var i = 0; i< this.state.arr_data.length; i++){
    if(this.state.arr_data[i].isChecked == true){
     
      req_id = [...req_id, ...this.state.arr_data[i].req_ids];
      

    }
   }*/

    const payload = {
      //location: this.state.selectedLocation,
      //type: "assign",
      van_id: this.state.selectedVan1,
      order_id: arr,
      group_id: this.state.selectedGroup,
      //req_ids: req_id
    };

    API.post("/master_ptl/van/v1/assign/", { param: payload })
      .then((response) => {
        //alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        if (response.data.success == true) {
          this.toggle();
        } else {
          this.Failedtoggle();
        }
        this.setState({
          SuccessConfirmmodal: false,
          showCreatedId: false,
          showSelectGroup: false,
          showNewGroup: false,
          assignLoader: false,
          assignDisabled: false,
          createDisabled: false,
        });

        this.getBillList();
      })
      .catch(function (error) {});
  }

    AssignData1() {
    this.setState({
      assignLoader1: true,
      assignDisabled1: true,
      createLoader: true,
      disable_inbound: true
    });

     var arrayData = this.state.arr_data1.filter(
      (item) => item.isChecked === true
    );

     var arr_id = [];

     for(var i = 0; i < arrayData.length; i++){
      arr_id.push(arrayData[i].invoice_number)
     }
    
     //console.log("id====>>",arr_id);
     //return false;

   const payload = {
      
      batch_id: this.state.batch_id,
      invoice_no: arr_id,
    };
    addAnalytics('Review Saleable', 'Confirm Saleable Review', payload);

    API.post("/picking/confirmPurchaseReturn", {param: payload})
      .then((response) => {
        if(response.data.status == true){
          this.setState({
            success_message: response.data.message,
            createLoader: false
          })
          this.toggleNew();
          //this.fetchDispatch();


        }else{
          this.setState({
            failed_message: response.data.message,
            createLoader: false
          })
          this.Failedtoggle();
          //this.fetchDispatch();
        }
      })
      .catch(function (error) {});
  }

  
  UnAssignData() {
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr,
    };

    API.post("/product/product_master/v1/group/unassign/", { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });

        this.fetchDispatch();
      })
      .catch(function (error) {});
  }

  checkAll1() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: true,
      }));
      var arrayData = newData.filter((item) => item.isChecked === true);

      var totalBill = 0;
      var totalWeight = 0;
      var totalValue = 0;

      for (var i = 0; i < arrayData.length; i++) {
        var totalBill1 = arrayData[i].bill_count;
        var totalBillValue = totalBill + totalBill1;
        totalBill = totalBillValue;

        var totalWeight1 = arrayData[i].weight;
        var totalWeightValue = totalWeight + totalWeight1;
        totalWeight = totalWeightValue;

        var totalValue1 = arrayData[i].value;
        var totalValueTonnage = totalValue + totalValue1;
        totalValue = totalValueTonnage;
      }

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
        totalBillVal: totalBill,
        totalWeightVal: totalWeight.toFixed(2),
        totalTonnage: totalValue.toFixed(2),
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data1.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data1: newData,
        totalBillVal: 0,
        totalWeightVal: 0,
        totalTonnage: 0,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }

  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap1: this.assembleDispatchData1(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }

  checkedSingle(index, ischecked, orderid) {
    var arr = [];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true,
    });
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
    }

    console.log(newData);
    this.setState({
      tableRowsMap1: this.assembleDispatchData1(newData),
      //binData: newData,
    });
  }

  checkedSingle1(index, ischecked, orderid) {
    var arr = [];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true,
    });
    let newData = this.state.arr_data1;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      data_type = "assign";
      assign_arr.push(orderid);
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      data_type = "unassign";
      unassign_arr.push(orderid);
    }

    console.log(newData);

    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      arr_data1: newData,

      //binData: newData,
    });
  }


  toggleOKNew() {
    //this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    //this.fetchDispatch();
    window.location.reload();
  }

  toggleNew() {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    //this.fetchDispatch();
    window.location.href = '/receiving/create_ASN';
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle() {
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }

  toggleNPICancel() {
    this.setState((prevState) => ({
      modal1: !prevState.modal1,
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
    var arrayData = this.state.arr_data.filter((item) => item.van_master == "");

    var errMsg = arrayData.length + " " + "Bills are not assigned to any van";

    if (arrayData.length > 0) {
      this.setState({
        reviewErr: errMsg,
      });
    } else {
      this.setState({
        reviewErr: "",
      });
    }
    const payload = {
      //location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
    };

    API.post("/master_ptl/van/v1/orders/", { param: payload })
      .then((response) => {
        console.log(response);
        let reviewDataVal = response.data.data.map((item) => ({
          ...item,
          station: "",
          zone: "",
        }));
        this.setState({
          reviewData: reviewDataVal,
        });
      })
      .catch(function (error) {});
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }


  radioChange = (item_code) => {
    this.setState({
      inbound_id: item_code,
    });
  };




  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
    this.setState({
      // SuccessConfirmmodal: false,
      showCreatedId: false,
      showSelectGroup: false,
      showNewGroup: false,
      createDisabled: false,
    });
  }

  SuccessConfirmtoggle1() {
    this.setState((prevState) => ({
      SuccessConfirmmodal1: !prevState.SuccessConfirmmodal1,
    }));
    this.setState({
      // SuccessConfirmmodal: false,
      showCreatedId: false,
      showSelectGroup: false,
      showNewGroup: false,
      createDisabled: false,
    });
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    console.log(today);
    /* From_Date_val = this.convertDate(today);
      to_Date_val = this.convertDate(today);*/
    From_Date_val = "";
    to_Date_val = "";

    sessionStorage.setItem("PUstore_id", "");
    sessionStorage.setItem("PUpolaris_id", "");
    sessionStorage.setItem("PUstatus_type", "");
    sessionStorage.setItem("PUtask_type_value", "");
    sessionStorage.setItem("PUtask_id", "");

    /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    var invenOwner = Util.getCookie("invOwner");
    this.setState(
      {
        userName: cookieUsername,
        invenOwner: invenOwner,
        //fromdate:today,
        //todate:today,
        selectedLocation: Location,
        store_id:
          sessionStorage.getItem("store_id") == "null"
            ? ""
            : sessionStorage.getItem("store_id"),
        polaris_id:
          sessionStorage.getItem("polaris_id") == "null"
            ? ""
            : sessionStorage.getItem("polaris_id"),
        task_id:
          sessionStorage.getItem("task_id") == "null"
            ? ""
            : sessionStorage.getItem("task_id"),
        status_type:
          sessionStorage.getItem("status_type") == "null" ||
          sessionStorage.getItem("status_type") == ""
            ? "1"
            : sessionStorage.getItem("status_type"),
        task_type_value:
          sessionStorage.getItem("task_type_value") == "null"
            ? ""
            : sessionStorage.getItem("task_type_value"),
      },
      () => {
        this.fetchDispatch();
        this.getReason();
       
      }
    );

  }

  deleteCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };




  SuccessConfirmoktoggle() {
    var order_count = 0;
    var order_value = 0;
    var box_count = 0;
    var req_id = [];

    var area_code = [];
    for (var i = 0; i < this.state.arr_data.length; i++) {
      if (this.state.arr_data[i].isChecked == true) {
        order_count += this.state.arr_data[i].order_count;
        order_value += this.state.arr_data[i].order_value;
        box_count += this.state.arr_data[i].box_count;
        req_id = [...req_id, ...this.state.arr_data[i].req_ids];
        area_code.push(this.state.arr_data[i].area_code);
      }
    }

    var area_code_data = area_code.join(",");

    console.log(
      "order_count",
      order_count,
      "order_value",
      order_value,
      "box_count",
      box_count,
      "req_id",
      req_id,
      "area_code",
      area_code.join(",")
    );

    //return false;

    const payload = {
      location: this.state.selectedLocation,
      name: this.state.groupName,
      order_count: order_count,
      order_value: order_value,
      box_count: box_count,
      req_ids: req_id,
      area_code: area_code_data,
    };

    API.post("/sdr/vans/v1/create/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log(data);

        this.setState({
          selectedVan: data.data.van_id,
          showCreatedId: true,
          createDisabled: true,
          assignDisabled: false,
        });
      })

      .then(async () => {});
  }




  onPONumberChange = (e) => {
    const value = e.target.value;
    this.setState({
      po_number: value,
    });
  };



  onBillRangeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_range: value,
    });
  };

  onBillValueeChange = (e) => {
    const value = e.target.value;
    this.setState({
      bill_value: value,
    });
  };

  onWeightChange = (e) => {
    const value = e.target.value;
    this.setState({
      weight: value,
    });
  };

  onVolumeChange = (e) => {
    const value = e.target.value;
    this.setState({
      volume: value,
    });
  };

  onVanFilterChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedVanFilter: value,
    });
  };

  changeProductName = (e) => {
    const value = e.target.value;
    this.setState({
      autoProductName: value,
      color_product: false,
    });
  };

  onQuantityChangePackSize = (e) => {
    const value = e.target.value;
    this.setState({
      autoPackSize: value,
      packSize: value,
      color_packSize: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  onQuantityChangeTax = (e) => {
    const value = e.target.value;
    this.setState({
      tax_percentage1: value,
      color_tax: false,
    });
  };

  onQuantityChangeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      autoVariant: value,
      variant: value,
      color_variant: false,
    });
  };

  OpenAssign() {
    this.SuccessConfirmtoggle();
  }

  OpenAssign1() {
    this.SuccessConfirmtoggle1();
  }

  handleChange1 = (e) => {
    this.setState({
      selectedGroup: e.target.value,
      assignDisabled: false,
    });
  };

  handleChangeASN(e, callback) {
    const value = e.target.value
      ? e.target.value.replace(/[^0-9a-zA-Z]+/gi, "")
      : "";
    console.log("value", value);
    this.setState({
      selectedASN: value,
      assignDisabled: false,
    });

    if (e.target.value !== value) {
      e.target.value = value;
    }
  }

  getReason() {
    const payload = {
      location: this.state.selectedLocation,
      screen_type: "edit_ptl",
    };
    API.post("/product/product_master/v1/reason/dropdown/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        console.log("REASON", data);
        this.setState({ reasonData: data.data });
      })

      .then(async () => {});
  }

  handleChangeVan1(e, callback) {
    const value = e.target.value
      ? e.target.value.replace(/[^0-9a-zA-Z]+/gi, "")
      : "";
    console.log("value", value);
    this.setState({
      selectedVan1: value,
      assignDisabled: false,
    });

    if (e.target.value !== value) {
      e.target.value = value;
    }
  }

  validateInput = (e) => {
    alert("rtyt");
    var k = e.keyCode || e.which;
    var ok =
      (k >= 65 && k <= 90) || // A-Z
      (k >= 96 && k <= 105) || // a-z
      (k >= 35 && k <= 40) || // arrows
      k == 9 || //tab
      k == 46 || //del
      k == 8 || // backspaces
      (!e.shiftKey && k >= 48 && k <= 57); // only 0-9 (ignore SHIFT options)

    if (!ok || (e.ctrlKey && e.altKey)) {
      e.preventDefault();
    }
  };

  ChangeLocation = (e) => {
    this.setState({
      selectedLocation1: e.target.value,
    });
  };

  ChangeOutlet = (e) => {
    this.setState({
      selectedOutlet: e.target.value,
    });
  };

  ChangeDistributor = (e) => {
    this.setState({
      selectedDistributor: e.target.value,
    });
  };

  ChangeOrder = (e) => {
    this.setState({
      selectedOrder: e.target.value,
    });
  };

  radioChangeGroup(data) {
    if (data == "exsisting") {
      this.setState({
        showSelectGroup: true,
        showNewGroup: false,
        assignDisabled: true,
      });
    } else if (data == "new") {
      this.setState({
        showSelectGroup: false,
        showNewGroup: true,
        assignDisabled: true,
      });
    }
  }

  handleChange2 = (e) => {
    this.setState({
      task_id: e.target.value,
    });
  };
  handleChange3 = (e) => {
    this.setState({
      polaris_id: e.target.value,
    });
  };
  handleChange4 = (e) => {
    this.setState({
      task_type_value: e.target.value,
    });
  };

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  addCrate(evt, index, sorting_bin, lb_sku_id, total_qty, count, prod_config) {
    //alert("tyytyu");
    let newData = this.state.arr_data1;
    var obj = {};
    obj["sorting_bin"] = sorting_bin;
    obj["lb_sku_id"] = lb_sku_id;
    obj["total_qty"] = total_qty;
    obj["crate"] = "";
    obj["crate_id"] = "";
    obj["count"] = count;
    obj["prod_config"] = prod_config;
    obj["new"] = true;
    obj["edit_val"] = 0;

    newData.splice(index + 1, 0, obj);
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
    });
  }

  changeCrateQty(e) {
    this.setState({
      crateQty: e.target.value,
    });
  }

  changeCount(e) {
    this.setState({
      count: e.target.value,
    });
  }

  changeCrateId(e, index, id, flag) {
    this.setState({
      crateId: e.target.value,
    });

    var arrayData = [];

    var obj = {};
    obj["receiving_hist_id"] = id;
    obj["total_qty"] = this.state.count;
    obj["crate"] = this.state.crateQty;
    obj["crate_id"] = this.state.crateId;
    obj["crate_flag"] = flag;

    arrayData.push(obj);

    const payload = {
      arrayData,
    };
    API.post("/receiving/updateCrate/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("REASON", data);
      })
      .then(async () => {});
  }

  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData);
    let DispatchData = dispatchData.map((post, index) => {
      return {
        //action: post.checkbox == 0 ? <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle1(index,post.isChecked, post.id)}/> : "",
        action:
          post.status == "Inbound Created" ? (
            <input
              type="radio"
              style={{ width: 18, height: 18 }}
              disabled
              name="action"
            />
          ) : (
            <input
              type="radio"
              style={{ width: 18, height: 18 }}
              name="action"
              onChange={() => this.radioChange(post.id)}
            />
          ),
        po_number: post.po_number,
        type: post.type,
        po_date: post.po_date,
        total_line: post.total_line,
        total_value: post.total_value,
        status: post.status,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  assembleDispatchData1 = (dispatchData) => {
    console.log("dispatchData", dispatchData);
    let DispatchData1 = dispatchData.map((post, index) => {
      return {
        action: (
          <input
            style={{ textAlign: "center" }}
            type="checkbox"
            value={post.isChecked}
            checked={post.isChecked}
            onChange={() => this.checkedSingle(index, post.isChecked, post.id)}
          />
        ),

        //area_code: <span style={{color:'#70bbfc', cursor: 'pointer'}} onClick={() => this.getBillList(index,post.area_code)}>{post.area_code}</span>,
        rec_bin: post.sorting_bin__bin_address,
        product_id: post.product__lb_sku_id,
        product_desc: post.product__lb_sku_product_name,
        batch: post.receiving_request__batch,
        pkd: post.pkd,
        mrp: post.product__mrp,
        total_qty: (
          <input
            value={post.received_qty}
            style={{ fontSize: 12, height: 31, width: 120 }}
            type="text"
            className="form-control"
            placeholder="Enter Packed Qty"
            onChange={(evt) => this.changePackedQty(evt, index, post.id)}
          />
        ),
        status: (
          <span>
            {" "}
            <select
              className="form-control"
              disabled={post.child_product == true ? true : false}
              defaultValue={post.reason}
              style={{ fontSize: 13, width: 120 }}
              onChange={(evt) => this.changeReason(evt, index, post.id)}
            >
              <option value="">Select Reason</option>
              {this.state.reasonData.length > 0 &&
                this.state.reasonData.map((reasonData) => {
                  return (
                    <option value={reasonData.id}> {reasonData.name}</option>
                  );
                })}
            </select>{" "}
            <br />{" "}
            {post.isChecked == "true" && (
              <span
                className={"err_reason_" + post.id}
                style={{ fontSize: 12, color: "red" }}
              >
                {" "}
                Please Select Reason
              </span>
            )}
          </span>
        ),
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData1;
  };

 

 

  onConfirmProduct() {
    this.setState({
      disable_submit_button: true,
      ShowEditLoader: true,
    });
    var arr = [];
    for (var i = 0; i < this.state.reviewData.length; i++) {
      var obj = {};
      obj["van_id"] = this.state.reviewData[i].van_id;
      obj["zone"] = this.state.reviewData[i].zone;

      arr.push(obj);
    }
    console.log(arr);

    const payload = {
      data_list: arr,
      ptl_type: "manual_ptl",
      customer: this.state.invenOwner,
    };

    API.post("/packing/van/v1/confirm/pick/pack/planning/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          //success_message: data.message,
          failed_message: data.message,
          disable_submit_button: false,
          ShowEditLoader: false,
          totalBillVal: 0,
          totalTonnage: 0,
          totalWeightVal: 0,
        });

        if (data.success == true) {
          var objData = Object.keys(data.data)
            .map(function (k) {
              return data.data[k];
            })
            .join(",");
          var objKey = Object.keys(data.data)
            .map(function (k) {
              return k;
            })
            .join(",");
          console.log("objData", objData);
          console.log("objKey", objKey);
          this.setState({
            success_message:
              "Sub-Group-Id " +
              " " +
              objData +
              "is created for Van" +
              " " +
              objKey,
          });
          this.toggle2();
          this.toggleNew();
        } else {
          //this.toggle2();
          this.toggleFailed();
        }

        this.fetchDispatch();
      })
      .catch(function (error) {});
  }

 
  SearchData() {
    console.log("ARR", this.state.arr_data);
    this.setState({
      loading_overlay: true,
    });
    var newArrData = [];

    newArrData = this.state.arr_data.filter(
      (item) =>
        item.party_code == this.state.selectedOutlet ||
        item.distributor_code == this.state.selectedDistributor ||
        item.delivery_center == this.state.selectedLocation ||
        item.outlet_order_no == this.state.selectedOrder
    );

    console.log("filterData", newArrData);

    this.setState({
      arr_data: newArrData,
      tableRowsMap: this.assembleDispatchData(newArrData),
    });
  }

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
  };

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };

  FromDateChange = (date) => {
    console.log("Form date", date);
    this.setState({
      fromdate: date,
    });
    if (date != null) {
      From_Date_val = this.convertDate(date);
    } else {
      From_Date_val = "";
    }
  };

  ToDateChange = (date) => {
    const d = new Date(date);
    this.setState({
      todate: date,
    });

    if (date != null) {
      to_Date_val = this.convertDate(date);
    } else {
      to_Date_val = "";
    }
  };

  getZone = () => {
    const payload = {
      station_type: "PTL",
    };

    API.post("/product/product_master/v1/station/dropdown/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("Zone", data);
        this.setState({
          zoneData: data.data,
        });
      })
      .catch(function (error) {});
  };


  getStation = () => {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post("/product/product_master/v1/station/type/dropdown/", {
      param: payload,
    })
      .then((response) => response.data)
      .then((data) => {
        console.log("Station", data);
        this.setState({
          stationData: data.data,
        });
      })
      .catch(function (error) {});
  };

  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem("batch_id");

  

    const payload = {
      location: this.state.selectedLocation,
      po_number: this.state.po_number,
      start_date: From_Date_val,
      //"data_type": "unassigned",
      end_date: to_Date_val,
    };

    API.get("/picking/fetchPurchaseReturn")
      .then((response) => response.data)
      .then((data) => {
        console.log("21240086020", data);
        this.setState({
          showFetchDispatchData: true,
        });

        let AssignData = data.purchase_returns.map((item) => ({
          ...item,
          isChecked: false,
          edit_val: 2,
        }));

        console.log(AssignData);

         var new_data = {};
        var arr = [];

          for (var i = 0; i < AssignData.length; i++) {
            var tmp = AssignData[i];
            if (new_data[tmp.invoice_number] == undefined) {
              new_data[tmp.invoice_number] = [AssignData[i]];
            } else {
              new_data[tmp.invoice_number].push(AssignData[i]);
            }
          }

          console.log("new_data", new_data)
          arr.push(new_data)

          console.log("arrayData",arr);
          //return false;

        //return false;

        /*this.setState({
        showUnAssignedOrder: true,
        showAssignedOrder: false,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,

       })*/

        /*if (data.data.length == 0) {
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
          });
          return false;
        }*/

        this.setState({
          arr_data1: AssignData,
          batch_id: data.batch_id,
          tableRowsMap: this.assembleDispatchData(AssignData),
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
          inboundData: arr
        },() => { console.log("sfgsgsg")});
      })
      .catch(function (error) {});
  };

   removeData = (id)=>{
     API.get("/picking/removePurchaseReturn?purchase_return_id="+id)
      .then((response) => response.data)
      .then((data) => {
          if(data.status == true){
            this.setState({
              success_message: data.message
            })
            this.toggle();
            this.fetchDispatch();
          }else{
            this.setState({
              failed_message: data.message
            })
            this.Failedtoggle();
            this.fetchDispatch();
          }

      })
      .catch(function (error) {});

  }

changeCheckbox = (value, id)=>{
  //console.log(keyName);
  let { arr_data1 } = this.state;
 /*let newData = this.state.inboundData.keyName.forEach(function(item) {
    item.isChecked = true;
});*/
  /*let AssignData = tarr_data1.map((item) => {
         if(arr_data1.id == id){
          arr_data1.isChecked = true;
         }else{
          arr_data1.isChecked = false;
         }
        });*/

  console.log(id);

  for(var i = 0; i< arr_data1.length; i++){
    console.log(arr_data1[i].id, id,"====>");
    if(arr_data1[i].id == id){
      if(arr_data1[i].isChecked == false){
      arr_data1[i].isChecked = true
    }else{
      arr_data1[i].isChecked = false
    }
  }
  }

   console.log(arr_data1);

   var new_data = {};
        var arr = [];

          for (var i = 0; i < arr_data1.length; i++) {
            var tmp = arr_data1[i];
            if (new_data[tmp.invoice_number] == undefined) {
              new_data[tmp.invoice_number] = [arr_data1[i]];
            } else {
              new_data[tmp.invoice_number].push(arr_data1[i]);
            }
          }

          console.log("new_data", new_data)
          arr.push(new_data)

          console.log("arrayData",arr);
          addAnalytics('Review Saleable', 'Checkbox Selection', arr);

   this.setState({
    //arr_data1: arr_data1,
    //tableRowsMap: this.assembleDispatchData(arr_data1),
    inboundData: arr

   })



}


  getBillList(index, area_code) {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem("batch_id");

    const payload = {
      //location: this.state.selectedLocation1,
      //"data_type": "unassigned",
      group_id: this.state.selectedGroup,
      pl_group: this.state.pl_group,
      area_code: area_code,
      bill_range: this.state.bill_range,
      bill_value: this.state.bill_value,
      weight: this.state.weight,
      volume: this.state.volume,
      //outlet: this.state.selectedOutlet,
      //location: this.state.selectedLocation,
      from_data: From_Date_val,
      to_date: to_Date_val,
    };

    API.post("/master_ptl/view/v1/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        this.setState({
          showFetchDispatchData1: true,
        });

        var arr = data.data;

        const sortNullishValues = (arr = []) => {
          const assignValue = (val) => {
            if (val == "") {
              return val;
            } else {
              return Infinity;
            }
          };
          const sorter = (a, b) => {
            return assignValue(a.van_master) - assignValue(b.van_master);
          };
          arr.sort(sorter);
        };
        sortNullishValues(arr);
        console.log("sorter========", arr);

        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));

        this.setState({
          orderData: data.data,
          total_value: data.data.total_value,
          total_quantity: data.data.total_qty,
          arr_data: UnAssignData,
          tableRowsMap1: this.assembleDispatchData1(UnAssignData),
          showFetchDispatchData1: true,
          dispatch_status: false,
        });
        this.toggle1();
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2, modalNew } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal, Failedmodal, SuccessConfirmmodal1 } =
      this.state;
    const { EditModal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "#",

          field: "action",
          width: 45,
        },

        {
          label: "PO Number",

          field: "po_number",
          width: 110,
        },
        {
          label: "PO Type",

          field: "type",
          width: 90,
        },
        {
          label: "PO Date",

          field: "po_date",
          width: 90,
        },
        {
          label: "Total Line",

          field: "total_line",
          width: 90,
        },

        {
          label: "Total value",

          field: "total_value",
          width: 90,
        },

        {
          label: "Status",

          field: "status",
          width: 200,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    const dispatchData1 = {
      columns: [
        {
          //label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,
          label: "#",
          field: "action",
          width: 50,
        },

        {
          label: "Location",

          field: "rec_bin",
          width: 120,
        },
        {
          label: "Prod Id",

          field: "product_id",
          width: 100,
        },
        {
          label: "Prod Desc",

          field: "product_desc",
          width: 130,
        },

        {
          label: "Batch",

          field: "batch",
          width: 90,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 90,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 90,
        },
        {
          label: "Total Qty Actual/Expected",

          field: "total_qty",
          width: 180,
        },
        /*{
          label: "Outer Qty Actual/Expected",

          field: "outer_qty",
          width: 180,
        },
        {
          label: "Inner Qty Actual/Expected",

          field: "inner_qty",
          width: 180,
        },
        {
          label: "Each Qty Actual/Expected",

          field: "each_qty",
          width: 180,
        },*/
        {
          label: "Status",

          field: "status",
          width: 100,
        },
        {
          label: "Reason",

          field: "reason",
          width: 100,
        },
      ],

      rows: this.state.tableRowsMap1,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 12, display: 'none' }}>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div className="form__form-group-field">
                  <input
                    type="text"
                    className="form-control group_text1"
                    placeholder="PO Number"
                    onChange={this.onPONumberChange}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px", marginLeft: 15 }}
              >
                <div className="form__form-group-field">
                  <DatePicker
                    selected={this.state.fromdate}
                    onChange={this.FromDateChange}
                    className="ledger_fromdate"
                    placeholderText="Start Date"
                    format="yyyy-MM-dd"
                  />
                  {this.state.showFromErr && (
                    <span style={{ color: "red", fontSize: 11 }}>
                      Please Select From Date
                    </span>
                  )}
                </div>
              </div>
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="End Date"
                />
                {this.state.showToErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select To Date
                  </span>
                )}
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "none", marginBottom: "0px", marginTop: 10 }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    type="text"
                    className="form-control group_text1"
                    placeholder="Enter Van "
                    onChange={this.onVanFilterChange}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{
                  marginBottom: "0px",
                  marginRight: 12,
                  marginTop: 10,
                  display: "none",
                }}
              >
                <div className="form__form-group-field">
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.onBillRangeChange}
                  >
                    <option value="">Select Bill Range</option>

                    <option value="greater"> {"<"}</option>
                    <option value="equal"> {"="} </option>
                    <option value="less"> {">"}</option>
                  </select>
                  {/*<input type = "text" className="form-control group_text1" placeholder= "Enter Bill Range" onChange={this.onBillRangeChange}/> */}
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "none",
                  marginBottom: "0px",
                  marginRight: 12,
                  marginTop: 10,
                }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    type="text"
                    className="form-control group_text1"
                    placeholder="Enter Bill Value"
                    onChange={this.onBillValueeChange}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{
                  display: "none",
                  marginBottom: "0px",
                  marginRight: 6,
                  marginTop: 10,
                }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input
                    type="text"
                    className="form-control group_text1"
                    placeholder="Enter Weight"
                    onChange={this.onWeightChange}
                  />
                </div>
              </div>

              {/*<div
                className="form__form-group col-xl-2"
                style={{ marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <select
                    className="form-control"
                    value={this.state.store_id}
                    style={{ fontSize: 13 }}
                    onChange={this.ChangeLocation}
                  >
                    <option value="">Location</option>
                    {
                      this.state.location.length > 0 &&
                      this.state.location.map((store) => {
                        return (
                          <option value={store.location}> {store.location}</option>
                        );
                      })}
                  </select>
                </div>
              </div>*/}

              <div
                className="form__form-group col-xl-2"
                style={{ marginLeft: 20 }}
              >
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <div>
              <CardBody
                style={{ marginTop: 10, paddingTop: 12, paddingBottom: 0 }}
              >


               <Button
                    style={{
                      marginBottom: 20,
                      marginTop: 10,
                      paddingTop: 5,
                      paddingBottom: 5,
                      paddingLeft: 26,
                      paddingRight: 26,
                      fontWeight: "bold",
                    }}

                    disabled={this.state.disable_inbound}
                    variant="warning"
                    onClick={(e) => this.AssignData1()}
                  >
                    {" "}
                    {this.state.createLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>

              <Accordion id="accordian" allowZeroExpanded={true}>
          

              
        {this.state.inboundData.map((item, itemIndex) =>
          _.map(item, (value, key) => (
           <AccordionItem style={{width: '100%'}}>
            <input checked={value[0].isChecked} onChange={(e) => this.changeCheckbox(value[0].isChecked, value[0].id)} type= "checkbox" style={{marginTop: 2, marginRight: 10, float: 'left', width: 14}} />
                <AccordionItemHeading style={{float: 'left', width: '96%'}}>
                    <AccordionItemButton>
                       <span style={{fontWeight: 'bold'}}> Invoice:{key},  Item: {value.length}</span>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                     <div
                  className="dispatchData stock_check_data style_table"
                  style={{ marginTop: 1 }}
                >
                 
                  <div className="inbound_table">

                    <table>
                    <thead>
                      <tr>

                        <th>PO Number</th>
                        <th>ASN</th>
                        <th>Invoice</th>
                        <th> Prod </th>
                        <th> Mrp </th>
                        

                        <th>Return Qty</th>
                        <th>Return Rate</th>
                        <th> Action</th>
                      </tr>
                     </thead>

                     <tbody>

                       {
                            value.map((insideItem, index) => {
                                return (
                      <tr>
                        
                        <td>{insideItem.po_number}</td>
                        <td>{insideItem.asn_number}</td>
                        <td>{insideItem.invoice_number}</td>
                        <td>{insideItem.product_code}</td>
                        <td> {insideItem.mrp} </td>

                      
                        <td>{insideItem.qty}</td>
                         <td>{insideItem.cost}</td>
                        <td><i onClick={() => this.removeData(insideItem.id)} style={{color: 'red', cursor: 'pointer'}} class="fa fa-trash" aria-hidden="true"></i></td>
                      </tr>
                    )})}

                     </tbody>
                     </table>

                  </div>
                </div>
                </AccordionItemPanel>
            </AccordionItem>


                    
            )))}
           
        </Accordion>
               
              </CardBody>
            </div>
          )}
        </Card>

        <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOKNew}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modal} backdrop="static" toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          backdrop="static"
          toggle={this.toggleFailed}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Failedmodal}
          backdrop="static"
          toggle={this.Failedtoggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modal1}
          backdrop="static"
          toggle={this.toggle1}
          style={{ maxWidth: 1045, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Bill List
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 10 }}>
            <MDBDataTable
              scrollX
              scrollY
              maxHeight="350px"
              displayEntries={false}
              searching={false}
              striped
              bordered
              data={dispatchData1}
            />

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <Button
                  style={{ backgroundColor: "#ddd", color: "#fff" }}
                  className="modal_ok"
                  onClick={this.toggleNPICancel}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.OpenAssign}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Assign Van
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modal2}
          toggle={this.toggle2}
          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Review Data
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            ></div>

            {this.state.apply1 && (
              <div style={{ width: "100%", float: "left" }}>
                <span style={{ color: "red" }}>{this.state.reviewErr}</span>
                <table
                  className="table table-bordered table-hover"
                  id="tab_logic"
                >
                  <thead style={{ textAlign: "left" }}>
                    <tr>
                      <th>Van Name</th>
                      <th>Total Bill</th>
                      <th>Total Values </th>
                      <th>Total Weight </th>
                      <th>Location </th>
                      <th>Zone </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.reviewData.length > 0 &&
                      this.state.reviewData.map((item, index) => (
                        <tr>
                          <td>{item.van_name}</td>
                          <td>{item.total_bills}</td>
                          <td>{item.total_values}</td>
                          <td>{item.total_weight}</td>
                          <td>{item.locations}</td>
                          {/*<td>
                              <select
                                className="form-control"
                                value={this.state.store_id}
                                style={{ fontSize: 13 }}
                                
                                onChange={(evt) =>
                                  this.ChangeStation(evt, index)
                                }

                              >
                                <option value="">Select Station</option>
                                {
                                  this.state.stationData.length > 0 &&
                                  this.state.stationData.map((stationData) => {
                                    return (
                                      <option value={stationData.id}> {stationData.name}</option>
                                    );
                                  })}
                              </select>
                            </td>*/}
                          <td>
                            <select
                              className="form-control"
                              value={this.state.store_id}
                              style={{ fontSize: 13 }}
                              onChange={(evt) => this.ChangeZone(evt, index)}
                            >
                              <option value="">Select zone</option>
                              {this.state.zoneData.length > 0 &&
                                this.state.zoneData.map((zoneData) => {
                                  return (
                                    <option value={zoneData.id}>
                                      {" "}
                                      {zoneData.name} - {zoneData.type}
                                    </option>
                                  );
                                })}
                            </select>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 12 }}>
              <ButtonToolbar className="modal__footer">
                <Button
                  style={{ backgroundColor: "#ddd", color: "#fff" }}
                  className="modal_ok"
                  onClick={this.toggle2}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.onConfirmProduct}
                >
                  {this.state.ShowEditLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Create
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={SuccessConfirmmodal}
          backdrop="static"
          toggle={this.SuccessConfirmtoggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{ width: "70%" }}>Enter Van Name: </h5>

            <div style={{ marginTop: 6, width: "86%" }}>
              <input
                type="text"
                className="form-control group_text1"
                placeholder="Enter Van Name"
                onChange={this.handleChangeVan1}
              />
              {/*<select
                    className="form-control select_style"
                    value={this.state.store_id}
                    style={{ fontSize: 13,  width: 220 }}
                    onChange={this.handleChangeVan}
                  >
                    <option value="">Select Van</option>
                    {
                      this.state.van_list.length > 0 &&
                      this.state.van_list.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>*/}
            </div>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.SuccessConfirmtoggle}
            >
              Cancel
            </Button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
              disabled={this.state.assignDisabled}
            >
              {this.state.assignLoader && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={SuccessConfirmmodal1}
          backdrop="static"
          toggle={this.SuccessConfirmtoggle1}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr  modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5 style={{ width: "70%" }}>Enter ASN: </h5>

            <div style={{ marginTop: 6, width: "86%" }}>
              <input
                type="text"
                className="form-control group_text1"
                placeholder="Enter ASN"
                onChange={this.handleChangeASN}
              />
              {/*<select
                    className="form-control select_style"
                    value={this.state.store_id}
                    style={{ fontSize: 13,  width: 220 }}
                    onChange={this.handleChangeVan}
                  >
                    <option value="">Select Van</option>
                    {
                      this.state.van_list.length > 0 &&
                      this.state.van_list.map((store) => {
                        return (
                          <option value={store.id}> {store.name}</option>
                        );
                      })}
                  </select>*/}
            </div>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.SuccessConfirmtoggle1}
            >
              Cancel
            </Button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData1}
              disabled={this.state.assignDisabled1}
            >
              {this.state.assignLoader1 && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Assign
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
